import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { fadeInLeft, fadeInRight, staggerContainer } from '@/lib/animations';
import { ContactForm, ContactInfoDetails } from '@/components/info/ContactForm';

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="pt-24 min-h-screen bg-brand-black">
      <Helmet>
        <title>Contact Us — custum.ai</title>
        <meta name="description" content="Book a free discovery call or send us a message. We'll get back to you within 24 hours." />
        <meta property="og:title" content="Contact custum.ai" />
        <meta property="og:description" content="Ready to deploy AI? Let's talk. Book a free discovery call today." />
        <link rel="canonical" href="https://custum.ai/contact/" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Left Panel */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="lg:col-span-4"
          >
            <motion.p variants={fadeInLeft} className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-blue-light mb-4">
              CONTACT US
            </motion.p>
            <motion.h1 variants={fadeInLeft} className="text-4xl sm:text-5xl font-extrabold text-brand-white tracking-tight mb-4">
              Let's <span className="text-brand-blue">Talk</span>
            </motion.h1>
            <motion.p variants={fadeInLeft} className="text-base text-brand-muted leading-relaxed mb-10">
              Book a free discovery call or send us a message. We'll get back to you within 24 hours.
            </motion.p>

            <motion.div variants={fadeInLeft} className="mb-10">
              <ContactInfoDetails />
            </motion.div>
          </motion.div>

          {/* Right Panel - Form */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeInRight}
            className="lg:col-span-8"
          >
            <ContactForm formName="contact_page" />
          </motion.div>
        </div>
      </div>
    </div>
  );
}